import { html } from 'lit'
import { IconBase } from './icon-base.js'

class Icon extends IconBase {
  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        part="svg"
      >
        <path
          d="M10.3009 13.695L20.102 3.89754M10.5795 14.1356L12.8019 18.5805C13.339 19.6546 13.6075 20.1917 13.9458 20.3357C14.2394 20.4607 14.575 20.4381 14.8492 20.2748C15.1651 20.0867 15.3591 19.5185 15.7472 18.382L19.9463 6.08447C20.2845 5.09421 20.4535 4.59908 20.3378 4.27154C20.2371 3.9866 20.013 3.76246 19.7281 3.66179C19.4005 3.54607 18.9054 3.71514 17.9151 4.05328L5.61763 8.25242C4.48114 8.64049 3.91289 8.83453 3.72478 9.15044C3.56153 9.42459 3.53891 9.76019 3.66389 10.0538C3.80791 10.3921 4.34498 10.6606 5.41912 11.1977L9.86397 13.4201C10.041 13.5086 10.1295 13.5528 10.2061 13.6119C10.2742 13.6644 10.3352 13.7254 10.3876 13.7935C10.4468 13.8701 10.491 13.9586 10.5795 14.1356Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `
  }
}
customElements.define('send-icon', Icon)
